import React from 'react';
import { Badge } from '../ui/badge';
import { Urgency } from '../../lib/types';
interface UrgencyBadgeProps {
  urgency: Urgency;
}
export function UrgencyBadge({
  urgency
}: UrgencyBadgeProps) {
  let variant: 'default' | 'secondary' | 'destructive' | 'outline' = 'default';
  let className = '';
  switch (urgency) {
    case 'Redno':
      variant = 'secondary';
      className = 'bg-slate-100 text-slate-700 hover:bg-slate-200';
      break;
    case 'Nujno':
      variant = 'default';
      className = 'bg-orange-100 text-orange-700 hover:bg-orange-200';
      break;
    case 'Kritično':
      variant = 'destructive';
      className = 'bg-red-100 text-red-700 hover:bg-red-200';
      break;
  }
  return <Badge variant={variant} className={className} data-id="element-171">
      {urgency}
    </Badge>;
}